"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
// (C) 2007-2020 GoodData Corporation
/**
 * Return promise that will resolve after `ms` miliseconds
 *
 * @param ms - time in miliseconds
 * @returns
 */
function delay(ms) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(); }, ms);
    });
}
exports.delay = delay;
//# sourceMappingURL=promise.js.map